import $ from 'jquery'

const fillEbookLink = () => {
    // Fill Ebook form (form 3)
    $('[data-ebook-url]').each(function () {
        const $widget = $(this)
        const ebookUrl = $widget.attr('data-ebook-url') || $widget.data('ebook-url')

        if (!ebookUrl) return
        const $input = $widget.find('input[name="input_8"], #input_3_8')

        if ($input.length) {
            $input.val(ebookUrl)
        }
    })

    // Fill Webinar or other forms (form 5)
    $('[data-url]').each(function () {
        const $widget = $(this)
        const url = $widget.attr('data-url') || $widget.data('url')

        if (!url) return
        const $input = $widget.find('input[name="input_8"], #input_5_8')

        if ($input.length) {
            $input.val(url)
        }
    })
}

try {
    $(document).ready(fillEbookLink)
    $(document).on('gform_post_render', fillEbookLink)
    $(document).on('click', '[href*="off_canvas"]', () => setTimeout(fillEbookLink, 300))
} catch (error) {
    console.error('Failed to fill ebook link:', error)
}
